//
//
//
//
//
//
//
//
//
//
//
//

import { badgeObject } from "./objectBadges";

export default {
    name: "AQBadge",
    props: {
        badgeText: { type: String, default: "" },
        badgeColor: { type: String, default: "" },
        badgeType: { type: String, default: "STR" },
        background: { type: String, default: "" },
        noBorder: { type: Boolean, default: false }
    },
    computed: {
        badgeProps() {
            return badgeObject[this.badgeType.toLowerCase()];
        }
    },
    methods: {
        getLabel() {
            const translationArr = ["overdue", "attention", "at_risk", "on_track", "failed", "terminated", "suspended", "running",
                "completed", "archived", "published", "unpublished", "not_published", "unpublished_changes", "imported", "accepted", "pending",
                "rejected"];
            return translationArr.includes(this.badgeType.toLowerCase()) ? this.$t(this.badgeProps.type) : this.badgeProps.type;
        }
    }
};
